import {getField, updateField} from 'vuex-map-fields';
import BaseTableModule from '@/commonFunction/baseTableModule'

let calendar_date = new BaseTableModule('/ws/calendar_date/');

const state = {
    ...calendar_date.state,
    columns: [
        {text: 'Calendar date', value: 'calendar_date__dt', sortable: true, filterable: true, divider: true, brief: true, width: 80},
        {text: 'Human user', value: 'human_user__employee_number', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Staff contract', value: 'staff_contract', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Work', value: 'work', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Work tracker', value: 'work_tracker', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Sick', value: 'sick', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Vacation', value: 'vacation', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Max possible', value: 'max_possible', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Plan', value: 'plan', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Events', value: 'event_type_array', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Error', value: 'error', sortable: true, filterable: true, divider: true, brief: true,},
    ],
    columnsPublicHoliday: [
        {text: '', value: 'edit', sortable: false, filterable: true, divider: true, brief: true, width: 30},
        {text: '', value: 'delete', sortable: false, filterable: true, divider: true, brief: true, width: 30},
        {text: 'Date', value: 'dt', sortable: false, filterable: true, divider: true, brief: true, width: 80},
        {text: 'Holiday', value: 'public_holiday', sortable: false, filterable: true, divider: true, brief: true,},
    ],
    briefView: true,
    options: {
        page: 1,
        itemsPerPage: 50,
        sortBy: ['-id'],
        sortDesc: [false],
        multiSort: false,
        mustSort: true,
        descending: true,
    },
};
const getters = {
    ...calendar_date.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...calendar_date.actions,
};
const mutations = {
    ...calendar_date.mutations,
};

export default {
    modules: {
        CalendarDate: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}